import { Box, BoxProps } from "@mui/material";

// TODO: 枠線あり・なしを定義できるようにする。

export type STextProps = Pick<BoxProps, "children"> &
  Partial<Pick<BoxProps, "gridColumn" | "gridRow" | "color">> &
  Partial<{
    align: "left" | "right" | "center";
    bordered: boolean;
  }>;

export const SText = ({
  children,
  gridColumn,
  gridRow,
  color,
  ...props
}: STextProps) => {
  if (typeof props.align === "undefined") props.align = "center";
  let borderedProps;
  if (props.bordered) {
    borderedProps = {
      border: 1,
      borderColor: "#b9c0c2",
    };
  }
  return (
    <Box gridColumn={gridColumn} gridRow={gridRow}>
      <Box
        display="flex"
        justifyContent={props.align}
        {...borderedProps}
        color={color}
      >
        {children}
      </Box>
    </Box>
  );
};
